module.exports = __webpack_public_path__ + "img/settings-to-chart.accc9bbf.svg";